import moment from 'moment'
import React, { useState } from 'react'
import ScrollTable from '../../ScrollTable'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import TextField from '@mui/material/TextField'
import { useNavigate } from 'react-router-dom'
export default function Users ({ leads }) {
  const navigate = useNavigate();
  const [type, settype] = useState('')
  const [plantype, setplantype] = useState('')
  const [plannametype, setplannametype] = useState('')
  const [status, setstatus] = useState('')
  const [searhName, setsearhName] = useState('')
  const [searchEmail, setsearchEmail] = useState('')
  const [source, setsource] = useState('')

  const [startDate, setStartDate] = useState(new Date('Sun Jan 01 2022'))
  const [endDate, setEndDate] = useState(new Date())

  return (
    <div style={{ height: '100%' }}>
      <div className='sales-filter-bar sales-filter-bar--grid'>
        <div className='sales-filter-meta'>
          <div className='sales-filter-legend'>
            {[['#16a34a','Verified'],['#ca8a04','Registered'],['#3b82f6','SignUp'],['#dc2626','Blocked']].map(([color, label]) => (
              <span key={label} className='sales-filter-legend-item'>
                <span className='sales-filter-legend-dot' style={{ background: color }} />
                {label}
              </span>
            ))}
          </div>
        <p className='sales-filter-count'>
          <span className='fw-6'>
            {leads &&
              leads
                .filter(lead => {
                  if (
                    lead.type !== 'fundmanager' &&
                    lead.type !== 'corporateuser' &&
                    lead.type !== 'academiauser'
                  )
                    return lead
                })
                .filter(lead => {
                  if (type === '') return lead
                  else if (lead.type === type) return lead
                })
                .filter(lead => {
                  if (plantype === '') return lead
                  else if (lead.plan.planName === plantype) return lead
                })
                .filter(lead => {
                  if (source === '') return lead
                  else if (lead.source === source) return lead
                })
                .filter(lead => {
                  if (status === '') return lead
                  else if (
                    status === 'Verified' &&
                    (lead.currentRegistrationStep === 10 || lead.name) &&
                    lead.isProfileVerified
                  )
                    return lead
                  else if (
                    status === 'Registered' &&
                    (lead.currentRegistrationStep === 10 || lead.name) &&
                    !lead.isProfileVerified
                  )
                    return lead
                  else if (
                    status === 'Sign Up' &&
                    lead.currentRegistrationStep !== 10 &&
                    !lead.isProfileVerified
                  )
                    return lead
                  else if (status === 'Blocked' && lead.isBlocked) return lead
                })
                .filter(lead => {
                  if (searhName === '') return lead
                  else if (
                    lead.name
                      ?.toLowerCase()
                      .includes(searhName.toLowerCase()) ||
                    lead.firstname
                      ?.toLowerCase()
                      .includes(searhName.toLowerCase()) ||
                    lead.lastname
                      ?.toLowerCase()
                      .includes(searhName.toLowerCase())
                  )
                    return lead
                })
                .filter(lead => {
                  if (searchEmail === '') return lead
                  else if (
                    lead.email
                      ?.toLowerCase()
                      .includes(searchEmail.toLowerCase())
                  )
                    return lead
                })
                .filter(lead => {
                  if (startDate === '' && endDate === '') return lead
                  const leadDate = new Date(lead.date)
                  const start = startDate ? new Date(startDate) : null
                  const end = endDate ? new Date(endDate) : null

                  if (start && end) {
                    return leadDate >= start && leadDate <= end
                  } else if (start) {
                    return leadDate >= start
                  } else if (end) {
                    return leadDate <= end
                  }
                })
                .filter(lead => {
                  if (!plannametype) return true
                  const nickname = lead.plan?.nickname?.split(' ')[0] || ''
                  const service = lead.plan?.service || ''
                  const filterValue = plannametype
                  return (
                    nickname.includes(filterValue) ||
                    service.includes(filterValue)
                  )
                }).length}
          </span>{' '}
          Results
        </p>
        </div>
        <div className='sales-filter-grid'>
        <div className='sales-filter-field sales-filter-field--wide'>
          <p className='mb-1'>Name</p>
          <input
            placeholder='Search Name'
            value={searhName}
            onChange={e => setsearhName(e.target.value)}
          />
        </div>
        <div className='sales-filter-field'>
          <p className='mb-1'>Email</p>
          <input
            placeholder='Search Email'
            value={searchEmail}
            onChange={e => setsearchEmail(e.target.value)}
          />
        </div>
        <div className='sales-filter-field'>
          <p className='mb-1'>Type</p>
          <select
            placeholder='Type'
            value={type}
            onChange={e => settype(e.target.value)}
          >
            <option value=''>All</option>
            <option value='startup'>Startup</option>
            <option value='investor'>Investor</option>
            <option value='fundcompany'>Fund Company</option>
            <option value='corporate'>Corporate</option>
            <option value='institute'>Academia</option>
            <option value='student'>Student</option>
          </select>
        </div>
        <div className='sales-filter-field'>
          <p className='mb-1'>Status</p>
          <select
            value={status}
            onChange={e => setstatus(e.target.value)}
          >
            <option value=''>All</option>
            <option value='Verified'>Verified</option>
            <option value='Registered'>Registered</option>
            <option value='Sign Up'>Only Signup</option>
            <option value='Blocked'>Blocked</option>
          </select>
        </div>
        <div className='sales-filter-field'>
          <p className='mb-1'>Plan</p>
          <select
            value={plantype}
            onChange={e => setplantype(e.target.value)}
          >
            <option value=''>All</option>
            <option value='Free'>Free</option>
            <option value='Freemium'>Freemium</option>
            <option value='Basic'>Basic</option>
            <option value='Premium'>Premium</option>
          </select>
        </div>
        <div className='sales-filter-field'>
          <p className='mb-1'>Plan Name</p>
          <select
            value={plannametype}
            onChange={e => setplannametype(e.target.value)}
          >
            <option value=''>All</option>
            <option value='Monthly'>Monthly</option>
            <option value='Annual'>Annual</option>
            <option value='360 Investor Readiness'>Investor Readiness</option>
            <option value='360 Investor Premium'>Investor Premium</option>
          </select>
        </div>
        <div className='sales-filter-field'>
          <p className='mb-1'>Source</p>
          <select
            value={source}
            onChange={e => setsource(e.target.value)}
          >
            <option value=''>All</option>
            <option value='google-ads'>Google Ads</option>
            <option value='linkedin'>linkedin</option>
            <option value='newsletter'>Newsletter</option>
            <option value='gdinvite'>Gd Invite</option>
            <option value='rajsingh'>Raj</option>
            <option value='nikolai'>Nikolai</option>
          </select>
        </div>
        <div className='sales-filter-field sales-filter-field--wide'>
          <p className='mb-1'>Select Timeline</p>
          <div className='sales-filter-date-range'>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={startDate}
                onChange={newValue => {
                  setStartDate(newValue)
                }}
                format='dd MMM yyyy'
                renderInput={params => (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='Start Date'
                    size='small'
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        background: '#f9fafb'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#e5e7eb'
                      },
                      '& .MuiInputBase-input': {
                        padding: '8.5px 8px'
                      }
                    }}
                  />
                )}
              />
            </LocalizationProvider>
            <span className='sales-filter-date-sep'>–</span>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={endDate}
                onChange={newValue => {
                  setEndDate(newValue)
                }}
                format='dd MMM yyyy'
                renderInput={params => (
                  <TextField
                    {...params}
                    variant='outlined'
                    label='End Date'
                    size='small'
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        background: '#f9fafb'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#e5e7eb'
                      },
                      '& .MuiInputBase-input': {
                        padding: '8.5px 8px'
                      }
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
        </div>
        </div>
      </div>
      <ScrollTable className='sales-table-wrap'>
      <table className='sales-table'>
        <thead><tr>
          <th>Status</th>
          <th>Type</th>
          <th>Name</th>
          <th>Contact Person</th>
          <th>Email</th>
          <th>Plan</th>
          <th>Phone</th>
          <th>Date</th>
          <th>Location</th>
          <th>Source</th>
        </tr></thead>
        <tbody>
        {leads
          .filter(lead => {
            if (
              lead.type !== 'fundmanager' &&
              lead.type !== 'corporateuser' &&
              lead.type !== 'academiauser'
            )
              return lead
          })
          .filter(lead => {
            if (type === '') return lead
            else if (lead.type === type) return lead
          })
          .filter(lead => {
            if (plantype === '') return lead
            else if (lead.plan.planName === plantype) return lead
          })
          .filter(lead => {
            if (source === '') return lead
            else if (lead.source === source) return lead
          })
          .filter(lead => {
            if (status === '') return lead
            else if (
              status === 'Verified' &&
              (lead.currentRegistrationStep === 10 || lead.name) &&
              lead.isProfileVerified
            )
              return lead
            else if (
              status === 'Registered' &&
              (lead.currentRegistrationStep === 10 || lead.name) &&
              !lead.isProfileVerified
            )
              return lead
            else if (
              status === 'Sign Up' &&
              lead.currentRegistrationStep !== 10 &&
              !lead.isProfileVerified
            )
              return lead
            else if (status === 'Blocked' && lead.isBlocked) return lead
          })
          .filter(lead => {
            if (searhName === '') return lead
            else if (
              lead.name?.toLowerCase().includes(searhName.toLowerCase()) ||
              lead.firstname?.toLowerCase().includes(searhName.toLowerCase()) ||
              lead.lastname?.toLowerCase().includes(searhName.toLowerCase())
            )
              return lead
          })
          .filter(lead => {
            if (searchEmail === '') return lead
            else if (
              lead.email?.toLowerCase().includes(searchEmail.toLowerCase())
            )
              return lead
          })
          .filter(lead => {
            if (startDate === '' && endDate === '') return lead
            const leadDate = new Date(lead.date)
            const start = startDate ? new Date(startDate) : null
            const end = endDate ? new Date(endDate) : null

            if (start && end) {
              return leadDate >= start && leadDate <= end
            } else if (start) {
              return leadDate >= start
            } else if (end) {
              return leadDate <= end
            }
          })
          .filter(lead => {
            if (!plannametype) return true
            const nickname = lead.plan?.nickname?.split(' ')[0] || ''
            const service = lead.plan?.service || ''
            const filterValue = plannametype
            return (
              nickname.includes(filterValue) || service.includes(filterValue)
            )
          })
          .map((lead, i) => (
            <tr key={i}>
              <td>
                <span className='sales-status-dot' style={{ background: lead.isBlocked ? '#dc2626' : (lead.currentRegistrationStep === 10 || lead.name) && lead.isProfileVerified ? '#16a34a' : lead.currentRegistrationStep === 10 && !lead.isProfileVerified ? '#ca8a04' : '#3b82f6' }} />
                {['startup','investor','fundcompany'].includes(lead.type) ? lead.currentRegistrationStep : ''}
              </td>

              <td className='text_capi fw-5'>
                {lead.type === 'fundcompany'
                  ? 'Fund Company'
                  : lead.type === 'institute'
                  ? 'Academia'
                  : lead.type}
              </td>
              <td className='fw-5 pointer' onClick={() =>
                      navigate(`/admin/user-activity?tab=13&userid=${lead?._id}`)
                    }>{lead.name}</td>
              <td className='fw-5'>{lead.firstname + ' ' + lead.lastname}</td>
              <td className='fw-5'>
                <a
                  href={`mailto:${lead.email}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  {lead.email}
                </a>
              </td>
              <td className='fw-5'>
                {lead.plan.planName}
                {(lead?.plan?.nickname || lead.plan.service) && (
                  <>
                    {' ('}
                    {lead.plan.nickname?.split(' ')[0]}
                    {lead.plan.nickname && lead.plan.service && ' | '}
                    {lead.plan.service && `${lead.plan.service}`}
                    {')'}
                  </>
                )}
              </td>
              <td className='fw-5'>{lead.phone}</td>
              <td className='fw-5'>{moment(lead.date).format('DD-MM-YYYY')}</td>
              <td className='fw-5'>
                {lead.logindevices[0]?.iplocation?.country}
              </td>
              <td className='fw-5'>{lead.source}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </ScrollTable>
    </div>
  )
}
